import { get, put } from '../utils/api';
import { DepartmentResponse } from '../features/AppSkillRating/AppSkillRatingTypes';
import { formatUrl } from '../utils/urlFormatter';
import { updateTeamsPayload } from '../features/teams/teamsTypes';


const fetch_app_skill_details = '/{0}/{1}/{2}/appSkillRating.list'
const update_app_skill_details = '/{0}/{1}/appSkillRating.update'

const credentialsConfig = {
  withCredentials: true,
}

export const fetchAppSkillData = async (baseId: number, appId: number, appScoreId: number): Promise<DepartmentResponse> => {
  const fetch_skill_data = formatUrl(fetch_app_skill_details, [baseId, appId, appScoreId]);
  return get<DepartmentResponse>(fetch_skill_data, credentialsConfig);
};

export const updateAppSKillData = async (baseId: number, id: number, data: updateTeamsPayload): Promise<DepartmentResponse> => {
    const update_teams_data = formatUrl(update_app_skill_details, [baseId, id]);
    return put<DepartmentResponse>(update_teams_data, data, credentialsConfig);
};

